import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";
import { useLanguage, type Language } from "@/contexts/LanguageContext";

const languages: { code: Language; label: string; shortLabel: string }[] = [
  { code: "pt", label: "Português", shortLabel: "PT" },
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "es", label: "Español", shortLabel: "ES" },
];

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const currentLanguage = languages.find((entry) => entry.code === language);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-2"
          aria-label={`Alterar idioma. Idioma atual: ${currentLanguage?.label ?? language}`}
        >
          <Globe className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">{currentLanguage?.shortLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((entry) => (
          <DropdownMenuItem
            key={entry.code}
            onClick={() => setLanguage(entry.code)}
            className={language === entry.code ? "bg-muted" : ""}
            aria-current={language === entry.code ? "true" : undefined}
          >
            <span className="mr-2 text-xs font-semibold uppercase text-muted-foreground">
              {entry.shortLabel}
            </span>
            {entry.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageToggle;
